import { CustomerSucessController } from "@talentbait/shared-components";
import { useCallback } from "react";

import logger from "../utils/LoggerFrontend";
import Actions from "../Actions";

const useArchivePicture = (campaignData, userProfile) => {
  const archivePictureCallback = useCallback(
    (url, source) => {
      const { id: campaignId } = campaignData || {};
      const { organizationId: orgaId, userName } = userProfile || {};

      Actions.archivePicture({ orgaId, campaignId, url, source });

      const refSuccess = Actions.archivePicture.completed.listen(() => {
        // Segment tracking
        CustomerSucessController.send("Image Archived", {
          orgaId,
          campaignId,
          url,
          source
        });

        // Orga log
        Actions.addOrgaLog(orgaId, {
          type: "user-archived-image",
          message: `User ${userName} archived image ${url}`,
          userName,
          createdAt: new Date().toISOString(),
          meta: {
            campaignId,
            url
          }
        });

        refSuccess();
      });

      const refFailed = Actions.archivePicture.failed.listen(() => {
        logger.log("error:hooks:useArdhivePicture", "There was an error archiving an image", {
          campaignId,
          url
        });

        Actions.addNotification("There was an error removing the image.", "error");
        refFailed();
      });
    },
    [campaignData, userProfile]
  );

  return {
    archivePictureCallback
  };
};

export default useArchivePicture;
